import {
    animate,
    state,
    style,
    transition,
    trigger
} from '@angular/animations';
import {
    AfterViewInit,
    Component,
    Input,
    OnDestroy,
    OnInit
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { StateService } from '@uirouter/core';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { distinctUntilKeyChanged, map, takeWhile } from 'rxjs/operators';
import * as fromAuth from '../app/auth/store/auth.reducer';
import * as fromUser from '../app/user-info/store/user.reducer';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import * as fromShared from './shared';
import { Process } from './shared';
import { Category } from './shared/category/category.model';
import { MenuItem } from './shared/efaact-primeng.module';
import { LoggingService } from './shared/services/logging/logging.service';
import { MessageStateService } from './shared/services/message-state.service';
import * as fromSettings from '../app/company-setting';
import * as fromUserSetting from '../app/user-setting/store';
import { IUser } from './user-info';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    styleUrls: ['./app.menu.component.scss'],
    standalone: false
})
export class AppMenuComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() reset: boolean;

    cpModel: any[];

    theme = 'efaact-blue';

    layout = 'blue';

    version = 'v3';

    public active = true;
    public userSub: Subscription;
    public userProcessCategories: Category[] = [];
    public cpMenuItems: IMenuItem[] = [];
    public mProcesses: IMenuItem[] = [];
    public initialProcess: Process;
    public initialCatID: any;
    authSub: Subscription;
    token: string;
    routerSub: Subscription;
    browserRefresh: number;

    constructor(
        public app: AppComponent,
        private store: Store<fromUser.State>,
        private authStore: Store<fromAuth.State>,
        private ss: StateService,
        private log: LoggingService,
        private messageStateService: MessageStateService
    ) {
        this.log.verbose({ type: 'AppMenuComponent::' });
    }

    public goto(process: Process, cat) {
        this.log.debug({ type: 'AppComponent:goto', process });
        this.store.dispatch(fromShared.clearProcess());
        this.store.dispatch(fromShared.upsertProcess({ process }));
        this.ss.go(process.RouteName.toLowerCase().replace('/', '.'), {
            process: { ...process, catId: cat }
        });
    }

    ngOnDestroy() {
        this.active = false;
    }

    ngAfterViewInit() {
        Promise.all([
            this.changeTheme('efaact-blue', 'light'),
            this.changeLayout('efaact-blue')
        ])
            .then(() => {
                this.log.verbose({ type: 'AppMenuComponent:styles loaded' });
            })
            .catch(e => {
                this.log.error({
                    type: 'AppMenuComponent:styles load failure',
                    e
                });
            });

        this.theme = 'efaact-blue';
        this.layout = 'efaact-blue';
        setTimeout(() => {
            const root = document.getElementById('efaaactcentral');
            if (root) root.style.opacity = '1';
        }, 100);
    }
    ngOnInit() {
        this.browserRefresh = this.navigationType();
        // this.changeLayout('joomla', true);
        this.authSub = this.authStore
            .pipe(
                takeWhile(_ => this.active),
                select(fromAuth.getAuth)
            )
            .subscribe(auth => {
                if (auth.token) {
                    this.token = auth.token;
                }
            });

        this.store
            .pipe(
                select(fromUser.getUserInfo),
                takeWhile(() => this.active),
            )
            .subscribe(userInfo => {
                this.store.dispatch(
                    fromUserSetting.getUserSettings({
                        EmployeeListID: userInfo.EmployeeListID,
                        EmpSettingID: 31
                    })
                );

                if (userInfo.DefaultRoleGroupID == 1) {
                    this.store.dispatch(fromSettings.getCompanySetting({SettingType: 'AdminMsg1'}));

                    this.store.dispatch(
                        fromSettings.getCompanySetting({
                            SettingType: 'MgrMsg1'
                        })
                    );

                    this.store.dispatch(
                        fromSettings.getCompanySetting({
                            SettingType: 'UserMsg1'
                        })
                    );
                } else if (
                    userInfo.DefaultRoleGroupID == 12024 ||
                    userInfo.DefaultRoleGroupID == 12025
                ) {
                    this.store.dispatch(
                        fromSettings.getCompanySetting({
                            SettingType: 'MgrMsg1'
                        })
                    );

                    this.store.dispatch(
                        fromSettings.getCompanySetting({
                            SettingType: 'UserMsg1'
                        })
                    );
                } else {
                    this.store.dispatch(
                        fromSettings.getCompanySetting({
                            SettingType: 'UserMsg1'
                        })
                    );
                }
            });

        this.userSub = this.store
            .pipe(
                takeWhile(_ => this.active),
                select(fromUser.getUser)
            )
            .subscribe(user => {
                this.cpMenuItems = [];
                this.mProcesses = [];
                if (user.userInfo.Initialcatid) {
                    this.initialCatID = user.userInfo.Initialcatid;
                }
                if (user.UserProcessCategories) {
                    this.userProcessCategories = user.UserProcessCategories;

                    this.userProcessCategories.forEach(cat => {
                        cat.UserProcesses.forEach(process => {
                            if (process.RouteName != null) {
                                if (
                                    process.RouteName ===
                                    user.userInfo.Initialroutename
                                ) {
                                    this.initialProcess = process;
                                }
                                this.mProcesses.push({
                                    label: process.ProcessTitle,
                                    icon: '',
                                    command: () => this.goto(process, cat)
                                });
                            }
                        });

                        this.cpMenuItems.push({
                            label: cat.CategoryName,
                            icon: '',
                            items: this.mProcesses
                        });

                        this.mProcesses = [];
                    });

                    if (
                        !this.initialProcess &&
                        user.userInfo.Initialroutename
                    ) {
                        this.initialProcess =
                            fromShared.resolveSystemRouteProcess(
                                user.userInfo.Initialroutename
                            );
                    }
                    // this.cpMenuItems.splice(0, 0, {
                    //     label: 'PROCESS LIST',

                    // });
                    this.cpModel = this.cpMenuItems;

                    this.app.model = [
                        {
                            //label: 'Dashboard',
                            icon: 'pi pi-th-large',
                            routerLink: ['dashboard'],
                            title: 'Dashboard',
                            // tooltipOptions: {
                            //     tooltipLabel: 'Dashboard',
                            //     tooltipPosition: 'right',
                            //     tooltipEvent: 'hover'
                            // },
                            command: event => {
                                this.log.verbose({
                                    type: 'Dashboard clicked',
                                    event
                                });
                                if (this.app.DetailSideNavVisible == true) {
                                    this.app.DetailSideNavVisible =
                                        !this.app.DetailSideNavVisible;
                                }
                                if (this.app.MessageSideNavVisible == true) {
                                    this.app.MessageSideNavVisible =
                                        !this.app.MessageSideNavVisible;
                                }
                                // this.app.onTopbarSubItemClick(event.originalEvent || event);
                            }
                        },
                        {
                            //label: 'Home',
                            icon: 'fa fa-fw fa-home',
                            routerLink: ['main'],
                            title: 'Home',
                            command: event => {
                                if (this.app.DetailSideNavVisible == true) {
                                    this.app.DetailSideNavVisible =
                                        !this.app.DetailSideNavVisible;
                                }
                                if (this.app.MessageSideNavVisible == true) {
                                    this.app.MessageSideNavVisible =
                                        !this.app.MessageSideNavVisible;
                                }
                                this.log.verbose({
                                    type: 'Home clicked',
                                    event
                                });
                                // this.app.onTopbarSubItemClick(event.originalEvent || event);
                            }
                        },
                        {
                            //label: 'Calendar',
                            icon: 'fa fa-fw fa-calendar-alt',
                            //routerLink: ['main'],
                            title: 'Company Calendar',
                            command: event => {
                                this.app.onTopbarCompanyCalendarClick(event);
                                if (this.app.DetailSideNavVisible == true) {
                                    this.app.DetailSideNavVisible =
                                        !this.app.DetailSideNavVisible;
                                }
                                if (this.app.MessageSideNavVisible == true) {
                                    this.app.MessageSideNavVisible =
                                        !this.app.MessageSideNavVisible;
                                }
                            }
                        },
                        {
                            //label: 'eF Checkup',
                            icon: 'fa fa-fw fa-exclamation-triangle',
                            //routerLink: ['main'],
                            title: 'eFAACT Checkup',
                            command: event => {
                                this.app.onMenuEFCheckupClick(event);
                                if (this.app.DetailSideNavVisible == true) {
                                    this.app.DetailSideNavVisible =
                                        !this.app.DetailSideNavVisible;
                                }
                                if (this.app.MessageSideNavVisible == true) {
                                    this.app.MessageSideNavVisible =
                                        !this.app.MessageSideNavVisible;
                                }
                            }
                        },
                        {
                            //label: 'Messages',
                            icon: 'fa fa-fw fa-envelope',
                            //routerLink: ['main'],
                            title: 'Messages',
                            badge: this.app.messageCount,
                            badgeStyleClass: this.app.messageBadgeStyle,
                            command: event => {
                                if (this.app.DetailSideNavVisible == true) {
                                    this.app.DetailSideNavVisible =
                                        !this.app.DetailSideNavVisible;
                                }
                                this.app.MessageSideNavVisible =
                                    !this.app.MessageSideNavVisible;
                            }
                        },
                        {
                            //label: 'Settings',
                            title: 'Settings',
                            icon: 'fa fa-fw fa-cog',
                            //routerLink: ['main'],
                            command: event => {
                                if (this.app.MessageSideNavVisible == true) {
                                    this.app.MessageSideNavVisible =
                                        !this.app.MessageSideNavVisible;
                                }
                                this.app.DetailSideNavVisible =
                                    !this.app.DetailSideNavVisible;
                            }
                        },
                        {
                            //label: 'eFAACT Store',
                            title: 'eFAACT Store',
                            icon: 'fa fa-fw fa-store',
                            routerLink: ['efaactstore'],
                            command: event => {
                                if (this.app.MessageSideNavVisible == true) {
                                    this.app.MessageSideNavVisible =
                                        !this.app.MessageSideNavVisible;
                                }
                                if (this.app.DetailSideNavVisible == true) {
                                    this.app.DetailSideNavVisible =
                                        !this.app.DetailSideNavVisible;
                                }
                            }
                        }
                        // {
                        //     label: 'Bootstrap Version', icon: 'fa fa-fw  fa-tags',
                        //     items: [
                        //         {label: 'Bootstrap v3', icon: 'fa fa-fw fa-tag',  command: () => this.changeVersion('v3')},
                        //         //{label: 'Bootstrap v4', icon: 'fa fa-fw fa-tag',  command: () => this.changeVersion('v4')}
                        //     ]
                        // },
                        // { label: 'Dashboard', icon: 'fa fa-fw fa-home', routerLink: ['/'] },
                        // {
                        //     label: 'Customization', icon: 'fa fa-fw fa-bars' , badge: '8',
                        //     items: [
                        //         {label: 'Static Menu', icon: 'fa fa-fw fa-bars',  command: () => this.app.changeToStaticMenu()},
                        //         {label: 'Overlay Menu', icon: 'fa fa-fw fa-bars',  command: () => this.app.changeToOverlayMenu()},
                        //         {label: 'Slim Menu', icon: 'fa fa-fw fa-bars',  command: () => this.app.changeToSlimMenu()},
                        //         {label: 'Horizontal Menu', icon: 'fa fa-fw fa-bars',  command: () => this.app.changeToHorizontalMenu()},
                        //         //{label: 'Inline Profile', icon: 'fa fa-sun-o fa-fw',  command: () => this.app.profileMode = 'inline'},
                        //         {label: 'Top Profile', icon: 'fa fa-moon-o fa-fw',  command: () => this.app.profileMode = 'top'},
                        //         {label: 'Light Menu', icon: 'fa fa-sun-o fa-fw',  command: () => this.app.darkMenu = false},
                        //         {label: 'Dark Menu', icon: 'fa fa-moon-o fa-fw',  command: () => this.app.darkMenu = true}
                        //     ]
                        // },
                        // {
                        //     label: 'Theme',
                        //     icon: 'fas fa-palette',
                        //     items: [
                        //         {
                        //             label: 'Light Mode',
                        //             icon: 'fas fa-sun',
                        //             command: () =>
                        //                 this.changeTheme('efaact-blue', 'light')
                        //         },
                        //         {
                        //             label: 'Dark Mode',
                        //             icon: 'fas fa-moon',
                        //             command: () =>
                        //                 this.changeTheme('efaact-blue', 'dark')
                        //         }
                        //     ]
                        // }
                    ];
                }
            });
    }

    // {
    //     label: 'Special',
    //     icon: 'fa fa-fw fa-fire',
    //     items: [
    //         //{label: 'Influenza', icon: 'fa fa-fw fa-paint-brush',
    //             //command: (event) => {this.changeLayout('influenza', true); }},
    //         //{label: 'Suzy', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeLayout('suzy', true); }},
    //         {label: 'Calm', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeLayout('calm', true); }},
    //         //{label: 'Crimson', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeLayout('crimson', true); }},
    //         //{label: 'Night', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeLayout('night', true); }},
    //         //{label: 'Skyling', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeLayout('skyline', true); }},
    //         //{label: 'Sunkist', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeLayout('sunkist', true); }},
    //         //{label: 'Little Leaf', icon: 'fa fa-fw fa-paint-brush',
    //             //command: (event) => {this.changeLayout('littleleaf', true); }},
    //         {label: 'Joomla', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeLayout('joomla', true); }},
    //         //{label: 'Firewatch', icon: 'fa fa-fw fa-paint-brush',
    //             //command: (event) => {this.changeLayout('firewatch', true); }}
    //     ]
    // }

    // {
    //     label: 'Process List',
    //     icon: 'fas fa-list',
    //     items: this.cpMenuItems,

    // },

    // {
    //     label: 'Themes', icon: 'fa fa-fw fa-paint-brush', badge: '5',
    //     items: [
    //         ////{label: 'Blue', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeTheme('blue'); }},
    //         ////{label: 'Cyan', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeTheme('cyan'); }},
    //         //{label: 'Indigo', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeTheme('indigo'); }},
    //         ////{label: 'Purple', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeTheme('purple'); }},  //maybe
    //         ////{label: 'Teal', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeTheme('teal'); }},  //maybe
    //         //{label: 'Orange', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeTheme('orange'); }},
    //         //{label: 'Deep Purple', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeTheme('deeppurple'); }},
    //         ////{label: 'Light Blue', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeTheme('lightblue'); }},
    //         //{label: 'Green', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeTheme('green'); }},
    //         //{label: 'Light Green', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeTheme('lightgreen'); }},
    //         //{label: 'Lime', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeTheme('lime'); }},
    //         //{label: 'Amber', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeTheme('amber'); }},
    //         ////{label: 'Brown', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeTheme('brown'); }}, //maybe
    //         ////{label: 'Dark Grey', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeTheme('darkgrey'); }},  //myabe
    //         //{label: 'Pink', icon: 'fa fa-fw fa-paint-brush', command: (event) => {this.changeTheme('pink'); }},
    //     ]
    // },
    // {
    //     label: 'Components', icon: 'fa fa-fw fa-sitemap',
    //     items: [
    //         {label: 'Sample Page', icon: 'fa fa-fw fa-columns', routerLink: ['/sample']},
    //         {label: 'Forms', icon: 'fa fa-fw fa-code', routerLink: ['/forms']},
    //         {label: 'Data', icon: 'fa fa-fw fa-table', routerLink: ['/data']},
    //         {label: 'Panels', icon: 'fa fa-fw fa-list-alt', routerLink: ['/panels']},
    //         {label: 'Overlays', icon: 'fa fa-fw fa-square', routerLink: ['/overlays']},
    //         {label: 'Menus', icon: 'fa fa-fw fa-minus-square-o', routerLink: ['/menus']},
    //         {label: 'Messages', icon: 'fa fa-fw fa-circle-o-notch', routerLink: ['/messages']},
    //         {label: 'Charts', icon: 'fa fa-fw fa-area-chart', routerLink: ['/charts']},
    //         {label: 'File', icon: 'fa fa-fw fa-arrow-circle-o-up', routerLink: ['/file']},
    //         {label: 'Misc', icon: 'fa fa-fw fa-user-secret', routerLink: ['/misc']}
    //     ]
    // },
    // {
    //     label: 'Template Pages', icon: 'fa fa-fw fa-life-saver',
    //     items: [
    //         {label: 'Empty Page', icon: 'fa fa-fw fa-square-o', routerLink: ['/empty']},
    //         {label: 'Landing Page', icon: 'fa fa-fw fa-certificate', url: 'assets/pages/landing.html', target: '_blank'},
    //         {label: 'Login Page', icon: 'fa fa-fw fa-sign-in', url: 'assets/pages/login.html', target: '_blank'},
    //         {label: 'Error Page', icon: 'fa fa-fw fa-exclamation-circle', url: 'assets/pages/error.html', target: '_blank'},
    //         {label: 'Not Found Page', icon: 'fa fa-fw fa-times', url: 'assets/pages/notfound.html', target: '_blank'},
    //         {label: 'Access Denied Page', icon: 'fa fa-fw fa-exclamation-triangle',
    //             url: 'assets/pages/access.html', target: '_blank'}
    //     ]
    // },
    // {
    //     label: 'Menu Hierarchy', icon: 'fa fa-fw fa-gg',
    //     items: [
    //         {
    //             label: 'Submenu 1', icon: 'fa fa-fw fa-sign-in',
    //             items: [
    //                 {
    //                     label: 'Submenu 1.1', icon: 'fa fa-fw fa-sign-in',
    //                     items: [
    //                         {label: 'Submenu 1.1.1', icon: 'fa fa-fw fa-sign-in'},
    //                         {label: 'Submenu 1.1.2', icon: 'fa fa-fw fa-sign-in'},
    //                         {label: 'Submenu 1.1.3', icon: 'fa fa-fw fa-sign-in'},
    //                     ]
    //                 },
    //                 {
    //                     label: 'Submenu 1.2', icon: 'fa fa-fw fa-sign-in',
    //                     items: [
    //                         {label: 'Submenu 1.2.1', icon: 'fa fa-fw fa-sign-in'},
    //                         {label: 'Submenu 1.2.2', icon: 'fa fa-fw fa-sign-in'}
    //                     ]
    //                 },
    //             ]
    //         },
    //         {
    //             label: 'Submenu 2', icon: 'fa fa-fw fa-sign-in',
    //             items: [
    //                 {
    //                     label: 'Submenu 2.1', icon: 'fa fa-fw fa-sign-in',
    //                     items: [
    //                         {label: 'Submenu 2.1.1', icon: 'fa fa-fw fa-sign-in'},
    //                         {label: 'Submenu 2.1.2', icon: 'fa fa-fw fa-sign-in'},
    //                         {label: 'Submenu 2.1.3', icon: 'fa fa-fw fa-sign-in'},
    //                     ]
    //                 },
    //                 {
    //                     label: 'Submenu 2.2', icon: 'fa fa-fw fa-sign-in',
    //                     items: [
    //                         {label: 'Submenu 2.2.1', icon: 'fa fa-fw fa-sign-in'},
    //                         {label: 'Submenu 2.2.2', icon: 'fa fa-fw fa-sign-in'}
    //                     ]
    //                 },
    //             ]
    //         }
    //     ]
    // },
    // {label: 'Utils', icon: 'fa fa-fw fa-wrench', routerLink: ['/utils']},
    // {label: 'Documentation', icon: 'fa fa-fw fa-book', routerLink: ['/documentation']}

    navigationType() {
        let result;
        let type;

        if (window.performance.navigation) {
            result = window.performance.navigation;
            if (result === 255) {
                result = 4;
            } // 4 is my invention!
        }

        if (window.performance.getEntriesByType('navigation')) {
            type =
                window.performance.getEntriesByType('navigation')[0].entryType;

            if (type === 'navigate') {
                result = 0;
            }
            if (type === 'reload') {
                result = 1;
            }
            if (type === 'back_forward') {
                result = 2;
            }
        }
        return result;
    }

    changeTheme(theme: string, mode = 'dark'): Promise<void> {
        const themeLink: HTMLLinkElement = document.getElementById(
            'theme-css'
        ) as HTMLLinkElement;
        this.log.verbose({
            type: 'AppMenuComponent:changeTheme'
        });
        return new Promise((r, j) => {
            try {
                // const t = setTimeout(() => {
                //     this.log.warn({
                //         type: 'AppMenuComponent:changeTheme',
                //         value: 'theme onload time out'
                //     });
                //     j(new Error('theme onload time out'));
                // }, 1000);
                // const onLoad = e => {
                //     this.log.verbose({
                //         type: 'AppMenuComponent:changeTheme:onload'
                //     });
                //     r();
                //     clearTimeout(t);
                // };

                // this.log.verbose({
                //     type: 'AppMenuComponent:changeTheme:Promise'
                // });

                // themeLink.onload = themeLink.oncancel = themeLink.onerror = onLoad;
                // themeLink.as = 'stylesheet';
                // themeLink.onload = onLoad;
                // themeLink.onerror = onLoad;

                themeLink.rel = 'stylesheet';
                themeLink.href = `assets/theme/${theme}/theme-${mode}.css?v=${environment.version}`;

                this.theme = theme;
                r();

                // onload not reliable, should be save after 1 sec
            } catch (e) {
                this.log.error({
                    type: 'AppMenuComponent:changeTheme',
                    e
                });
                j(e);
            }
        });
    }

    changeLayout(layout: string, special?: boolean): Promise<void> {
        const layoutLink: HTMLLinkElement = document.getElementById(
            'layout-css'
        ) as HTMLLinkElement;
        this.log.verbose({
            type: 'AppMenuComponent:changeLayout'
        });

        return new Promise((r, j) => {
            try {
                this.log.verbose({
                    type: 'AppMenuComponent:changeLayout:promise'
                });
                // const t = setTimeout(() => {
                //     this.log.warn({
                //         type: 'AppMenuComponent:changeLayout',
                //         value: 'layout onload time out'
                //     });
                //     j(new Error('layout onload time out'));
                // }, 1000);
                // const onLoad = e => {
                //     this.log.verbose({
                //         type: 'AppMenuComponent:changeLayout:onload',
                //         e
                //     });
                //     r();
                //     clearTimeout(t);
                // };
                // layoutLink.onload = layoutLink.oncancel = layoutLink.onerror = onLoad;
                // layoutLink.onload = onLoad;
                // layoutLink.onerror = onLoad;

                layoutLink.rel = 'stylesheet';
                layoutLink.href = `assets/layout/css/layout-${layout}.css?v=${environment.version}`;

                this.layout = layout;

                if (special) {
                    this.app.darkMenu = true;
                }
                r();
                // onload not reliable, should be save after 1 sec
            } catch (e) {
                this.log.error({
                    type: 'AppMenuComponent:changeLayout',
                    e
                });
                j(e);
            }
        });
    }
    // changeVersion(version: string) {
    //     const themeLink: HTMLLinkElement = document.getElementById(
    //         'theme-css'
    //     ) as HTMLLinkElement;
    //     const layoutLink: HTMLLinkElement = document.getElementById(
    //         'layout-css'
    //     ) as HTMLLinkElement;

    //     this.version = 'v3';
    //     themeLink.href = 'assets/theme/theme-' + this.theme + '.css';
    //     layoutLink.href = 'assets/layout/css/layout-' + this.layout + '.css';
    // }
}

@Component({
    /* tslint:disable:component-selector */
    selector: '[app-submenu]',
    /* tslint:enable:component-selector */
    //   <a (click)="itemClick($event,child,i)" (mouseenter)="onMouseEnter(i)" class="ripplelink" *ngIf="child.routerLink"
    //   [routerLink]="child.routerLink" routerLinkActive="active-menuitem-routerlink"
    //  [routerLinkActiveOptions]="{exact: true}" [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target">
    //   <i [ngClass]="child.icon"></i><span>{{child.label}}</span>
    //   <i class="fa fa-fw fa-angle-down menuitem-toggle-icon" *ngIf="child.items"></i>
    //   <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
    // </a>
    template: `
        <ng-template
            ngFor
            let-child
            let-i="index"
            [ngForOf]="root ? item : item.items"
        >
            <li
                [title]="child.title"
                [ngClass]="{ 'active-menuitem': isActive(i) }"
                [class]="child.badgeStyleClass"
                *ngIf="child.visible === false ? false : true"
            >
                <a
                    [href]="child.url || '#'"
                    (click)="itemClick($event, child, i)"
                    (mouseenter)="onMouseEnter(i)"
                    class="ripplelink"
                    [attr.tabindex]="!visible ? '-1' : null"
                    [attr.target]="child.target"
                >
                    <i [ngClass]="child.icon"></i><span>{{ child.label }}</span>
                    <i
                        class="fa fa-fw fa-angle-down menuitem-toggle-icon"
                        *ngIf="child.items"
                    ></i>
                    <span class="menuitem-badge" *ngIf="child.badge">{{
                        child.badge
                    }}</span>
                </a>

                <div class="layout-menu-tooltip">
                    <div class="layout-menu-tooltip-arrow"></div>
                    <div class="layout-menu-tooltip-text">
                        {{ child.label }}
                    </div>
                </div>
                <div class="submenu-arrow" *ngIf="child.items"></div>
                <ul
                    app-submenu
                    [item]="child"
                    *ngIf="child.items"
                    [visible]="isActive(i)"
                    [reset]="reset"
                    [parentActive]="isActive(i)"
                    [@children]="
                        (app.isSlim() || app.isHorizontal()) && root
                            ? isActive(i)
                                ? 'visible'
                                : 'hidden'
                            : isActive(i)
                            ? 'visibleAnimated'
                            : 'hiddenAnimated'
                    "
                ></ul>
            </li>
        </ng-template>
    `,
    animations: [
        trigger('children', [
            state('hiddenAnimated', style({
                height: '0px'
            })),
            state('visibleAnimated', style({
                height: '*'
            })),
            state('visible', style({
                display: 'block'
            })),
            state('hidden', style({
                display: 'none'
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ],
    styleUrls: ['./app.menu.component.scss'],
    standalone: false
})
export class AppSubMenuComponent {
    @Input() item: MenuItem;

    @Input() root: boolean;

    @Input() visible: boolean;

    _reset: boolean;

    _parentActive: boolean;

    activeIndex: number | null;

    constructor(public app: AppComponent) {}

    itemClick(event: Event, item: MenuItem, index: number) {
        if (this.root) {
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }

        // avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        // activate current item and deactivate active sibling if any
        this.activeIndex = this.activeIndex === index ? null : index;

        // execute command
        if (item.command) {
            item.command({ originalEvent: event, item });
        }

        // prevent hash change
        if (item.items || (!item.url && !item.routerLink)) {
            setTimeout(() => {
                this.app.layoutMenuScrollerViewChild.moveBar();
            }, 450);
            if (event) {
                event.preventDefault();
            }
        }

        // hide menu
        if (!item.items) {
            if (this.app.isHorizontal() || this.app.isSlim()) {
                this.app.resetMenu = true;
            } else {
                this.app.resetMenu = false;
            }

            this.app.overlayMenuActive = false;
            this.app.staticMenuMobileActive = false;
            this.app.menuHoverActive = !this.app.menuHoverActive;
        }
        if (item.routerLink) {
            if (event) {
                event.preventDefault();
            }
            this.app.goto({
                RouteName: item.routerLink[0]
            } as Process);
        }
    }

    onMouseEnter(index: number) {
        if (
            this.root &&
            this.app.menuHoverActive &&
            (this.app.isHorizontal() || this.app.isSlim()) &&
            !this.app.isMobile() &&
            !this.app.isTablet()
        ) {
            this.activeIndex = index;
        }
    }

    isActive(index: number): boolean {
        return this.activeIndex === index;
    }

    @Input() get reset(): boolean {
        return this._reset;
    }

    set reset(val: boolean) {
        this._reset = val;

        if (this._reset && (this.app.isHorizontal() || this.app.isSlim())) {
            this.activeIndex = null;
        }
    }

    @Input() get parentActive(): boolean {
        return this._parentActive;
    }

    set parentActive(val: boolean) {
        this._parentActive = val;

        if (!this._parentActive) {
            this.activeIndex = null;
        }
    }
}

@Component({
    /* tslint:disable:component-selector */
    selector: 'app-detail-menu',
    /* tslint:enable:component-selector */
    template: `
        <p-sidebar
            styleClass="layout-menu-dark"
            [(visible)]="app.DetailSideNavVisible"
            position="left"
            [modal]="false"
            [showCloseIcon]="false"
            [style]="DetailStyle"
            [dismissible]="true"
            [baseZIndex]="100"
            [transitionOptions]="'200ms cubic-bezier(.17,.67,.83,.67)'"
        >
            <ul class="mt-2 list-none p-0 mx-0">
                <h2>Settings</h2>
                <li class="my-2" *ngFor="let process of mainProcess$ | async">
                    <span class="text-600 text-sm font-medium ml-auto">{{
                        process.ProcessLabel
                    }}</span>
                    <button
                        pButton
                        class="p-button-secondary w-full mt-2"
                        (click)="
                            app.goto(process);
                            app.DetailSideNavVisible = !app.DetailSideNavVisible
                        "
                        [label]="process.ProcessTitle"
                    ></button>
                </li>
                <li class="my-2">
                    <span class="text-600 text-sm font-medium ml-auto">Update current password.</span>
                    <button
                        pButton
                        class="p-button-secondary w-full mt-2"
                        (click)="app.onChangePasswordClick(null);
                        app.DetailSideNavVisible = !app.DetailSideNavVisible"
                        label="Change Password"
                    ></button>
                </li>
            </ul>
        </p-sidebar>
    `,
    animations: [
        trigger('children', [
            state('hiddenAnimated', style({
                height: '0px'
            })),
            state('visibleAnimated', style({
                height: '*'
            })),
            state('visible', style({
                display: 'block'
            })),
            state('hidden', style({
                display: 'none'
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ],
    styleUrls: ['./app.menu.component.scss'],
    standalone: false
})
export class AppDetailMenuComponent {
    public mainProcess$: Observable<Process[]>;

    public DetailStyle = {
        'margin-top': '4rem',
        'margin-left': '4.9rem',
        'background-color': '#f2f2f2'
    };

    constructor(
        public app: AppComponent,
        private store: Store<fromUser.State>
    ) {
        this.mainProcess$ = this.store.pipe(
            select(fromUser.getUserProcessesMain),
            map(processes => processes.filter(p => p.displayinmenu))
        );
    }
}

@Component({
    /* tslint:disable:component-selector */
    selector: 'app-message-menu',
    /* tslint:enable:component-selector */
    template: `
        <p-sidebar
            styleClass="layout-menu-dark"
            [(visible)]="app.MessageSideNavVisible"
            position="left"
            [modal]="false"
            [showCloseIcon]="true"
            [style]="MessageStyle"
            [dismissible]="true"
            [baseZIndex]="100"
            [transitionOptions]="'200ms cubic-bezier(.17,.67,.83,.67)'"
        >
            <ul class="mt-2 list-none p-0 mx-0">
                <div style="display: grid">
                    <h2>Messages</h2>
                    <div style="justify-self: flex-end">
                    <div class="flex items-center">
                        <p-checkbox
                        inputId="mark"
                            [ngModel]="!this.showMsg" (ngModelChange)="this.showMsg = $event"
                            [binary]="true"
                            (onChange)="
                                onMarkAsRead(
                                    !this.showMsg,
                                    this.app.userInfo.EmployeeListID
                                )
                            "
                        ></p-checkbox>
                        <label for="mark" class="ml-2"> Mark as read </label>
                    </div>
                    </div>
                </div>

                <li class="my-2">
                    <div
                        *ngIf="adminMsg != null"
                        style="background-color: #FFFFFF; border-radius: 5px; padding: 2em; margin-bottom: 2em;"
                    >
                        <div [innerHTML]="adminMsg | safe: 'html'"></div>
                    </div>
                    <div
                        *ngIf="mgrMsg != null"
                        style="background-color: #FFFFFF; border-radius: 5px; padding: 2em; margin-bottom: 2em;"
                    >
                        <div [innerHTML]="mgrMsg | safe: 'html'"></div>
                    </div>
                    <div
                        *ngIf="userMsg != null"
                        style="background-color: #FFFFFF; border-radius: 5px; padding: 2em; margin-bottom: 2em;"
                    >
                        <div [innerHTML]="userMsg | safe: 'html'"></div>
                    </div>
                </li>
            </ul>
        </p-sidebar>
    `,
    animations: [
        trigger('children', [
            state('hiddenAnimated', style({
                height: '0px'
            })),
            state('visibleAnimated', style({
                height: '*'
            })),
            state('visible', style({
                display: 'block'
            })),
            state('hidden', style({
                display: 'none'
            })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ],
    styleUrls: ['./app.menu.component.scss'],
    standalone: false
})
export class AppMessageMenuComponent {
    public MessageStyle = {
        'margin-top': '4rem',
        'margin-left': '4.9rem',
        'background-color': '#f2f2f2',
        width: '30%'
    };
    public companySettings$: Observable<fromSettings.CompanySetting[]>;
    public userSettings$: Observable<Array<fromUserSetting.UserSetting>>;
    public userMsg;
    public mgrMsg;
    public adminMsg;
    messages: any[] = [];
    active = true;
    userMsgPushed = false;
    mgrMsgPushed = false;
    adminMsgPushed = false;
    showMsg: boolean;
    user: IUser;
    constructor(
        public app: AppComponent,
        private store: Store<fromUser.State>,
        private messageStateService: MessageStateService
    ) {
        this.userSettings$ = this.store.pipe(select(fromUserSetting.selectAll));
        this.companySettings$ = this.store.pipe(select(fromSettings.selectAll));

        combineLatest([this.companySettings$, this.userSettings$])
            .pipe(takeWhile(_ => this.active))
            .subscribe(([settings, userSettings]) => {
                if (userSettings.length > 0) {
                    if (userSettings[0].EmpSettingValue != null) {
                        this.showMsg =
                            userSettings[0].EmpSettingValue == '1'
                                ? true
                                : false;
                    }
                }

                this.userMsg =
                    settings.find(x => x.SettingType == 'UserMsg1') != null
                        ? settings.find(x => x.SettingType == 'UserMsg1')
                              .SettingValue
                        : null;
                this.mgrMsg =
                    settings.find(x => x.SettingType == 'MgrMsg1') != null
                        ? settings.find(x => x.SettingType == 'MgrMsg1')
                              .SettingValue
                        : null;
                this.adminMsg =
                    settings.find(x => x.SettingType == 'AdminMsg1') != null
                        ? settings.find(x => x.SettingType == 'AdminMsg1')
                              .SettingValue
                        : null;

                if (this.userMsg != null && this.userMsg != "") {
                    if (this.userMsgPushed == false) {
                        this.messages.push(this.userMsg);
                        this.userMsgPushed = true;
                    }
                }
                if (this.mgrMsg != null && this.mgrMsg != "") {
                    if (this.mgrMsgPushed == false) {
                        this.messages.push(this.mgrMsg);
                        this.mgrMsgPushed = true;
                    }
                }
                if (this.adminMsg != null && this.adminMsg != "") {
                    if (this.adminMsgPushed == false) {
                        this.messages.push(this.adminMsg);
                        this.adminMsgPushed = true;
                    }
                }

                // Update the message count in the service
                this.messageStateService.setMessageCount(this.messages.length);

                // Subscribe to the service for badge updates
                this.messageStateService.showBadge$.pipe(takeWhile(_ => this.active)).subscribe(showBadge => {
                    if (this.app.model && this.app.model.length > 0) {
                        const messageItem = this.app.model.find(x => x.title == 'Messages');
                        const messageIndex = this.app.model.findIndex(x => x.title == 'Messages');

                        if (messageItem && messageIndex !== -1) {
                            if (showBadge && this.messages.length > 0) {
                                this.app.messageBadgeStyle = 'ef-menuitem-badge-on';
                                messageItem.badgeStyleClass = this.app.messageBadgeStyle;
                                this.app.messageCount = this.messages.length.toString();
                                messageItem.badge = this.app.messageCount;
                            } else {
                                this.app.messageBadgeStyle = 'ef-menuitem-badge-off';
                                messageItem.badgeStyleClass = this.app.messageBadgeStyle;
                                this.app.messageCount = '';
                                messageItem.badge = this.app.messageCount;
                            }
                            this.app.model[messageIndex] = messageItem;
                        }
                    }
                });
            });
    }

    onMarkAsRead(showmsg, listid) {
        // Convert the showmsg parameter to the correct boolean format for the service
        // showmsg comes as '1' (show) or '0' (hide), we need to convert to markAsRead boolean
        const markAsRead = showmsg === '0';

        // Use the message state service to update the setting
        this.messageStateService.setMarkAsRead(markAsRead, listid);
    }

    ngOnDestroy() {
        this.active = false;
    }
}
export interface IMenuItem {
    label: string;
    icon?: string;
    items?: any[];
    command?: any;
    expanded?: boolean;
}
